import { useState } from "react";

import { DuplicateFrameModal } from "./DuplicateFrameModal";
import type { Frame } from "@/types/dragon-tiles";

import { useDuplicateFrame } from "@/api/dragon-tiles";

export interface DuplicateFrameRenderProps {
  open: () => void;
  isPending: boolean;
}

interface DuplicateFrameProps {
  frame: Frame;
  siteId: string;
  children: (props: DuplicateFrameRenderProps) => React.ReactNode;
  onSuccess?: () => void;
  onOpenChange?: (open: boolean) => void;
}

export function DuplicateFrame({
  frame,
  siteId,
  children,
  onSuccess,
  onOpenChange,
}: DuplicateFrameProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const duplicateFrame = useDuplicateFrame();

  const setOpen = (open: boolean) => {
    setIsModalOpen(open);
    onOpenChange?.(open);
  };

  return (
    <>
      {children({
        open: () => setOpen(true),
        isPending: duplicateFrame.isPending,
      })}
      <DuplicateFrameModal
        open={isModalOpen}
        onClose={() => setOpen(false)}
        frame={frame}
        siteId={siteId}
        onSuccess={onSuccess}
      />
    </>
  );
}
